import { get, post } from '@api/request';

export const fetchExemptionAuditRuns = async (
    { appraisalService },
    authenticationToken,
) => {
    const url = `${appraisalService}/hsaudit/exemptionaudits`;
    const { body } = await get(authenticationToken, url);
    return body;
};

export const createExemptionAuditRuns = async (
    { appraisalService },
    authenticationToken,
    { payload }
) => {
    const url = `${appraisalService}/hsaudit/exemptionaudits`;
    const { body } = await post(authenticationToken, url, payload);
    return body;
};